import {useState} from 'react';  

export default function SavedConfigurations({product, cart, productLink, canEdit, open, setOpen, onPartRemoved, 
 partNumbers, setPartNumbers})  {
 const formatPartNumber = (part) => {
      let partNumber = part.replace(/\|/g, ' - ').replace(/\:/g, '').replace(/\+/, ' + '); 
      let editLink = productLink + `?sku_parts=${encodeURIComponent(part.replace(/ /g, ''))}#lexcms-configurator-section` 
      return  {original: part, editLink: editLink, partNumber: partNumber}
  }
 
 
  const formattedPartNumbers = () =>  {
    return partNumbers.map((d, i) => formatPartNumber(d) )
  }

  const removePart = async (part) => {
    let ans =  confirm('Are you sure?');  
    if (ans) {
      let success = await cart.removePart(product.id, part)
      setPartNumbers((old) => old.filter((data) => data !== part )) 
    }
  }

  return (
    <div className='lexcms-parts-dropdown'>
     <div className='lexcms-parts-header'> 
       <div><strong> Configurations: </strong> <span>({partNumbers.length}) </span></div>
       <button onClick={()=>setOpen(false)}>Hide Configurations 
         <span className={`lexcms-accordion-arrow --open`}></span>
       </button>
     </div>
     {formattedPartNumbers().map((part, i) => {
        return (<div key={i} className='lexcms-part-container'> 
          <div className='lexcms-part-number-display'> 
            <div className='lexcms-part-number'>{part.partNumber}</div>
            <div className='lexcms-part-actions'>
              <a href={part.editLink}>View</a>

            {canEdit && 
              <a onClick={( ) => removePart(part.original)}>Delete</a>
            }
            </div>
          </div>
        </div>)
      })
      }
    </div>
  )

}
